import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { fetchInterviewByAccessToken } from '../services/interviewService';
import { normalizeInterviewTypeKey, isRecruitmentType } from '../utils/interviewType';

const resolveStatus = (data) => {
  if (!data) return null;
  if (data.finalEntrevista) {
    return {
      titulo: 'Entrevista concluída',
      descricao: 'Suas respostas já foram registradas. Obrigado(a) por participar.',
    };
  }
  const hasProgress =
    (Array.isArray(data.responses) && data.responses.length > 0) ||
    (Array.isArray(data.messages) && data.messages.length > 0);
  if (data.inicioEntrevista || hasProgress) {
    return {
      titulo: 'Entrevista em andamento',
      descricao: 'Você já começou a responder. Use o link do convite original pra continuar de onde parou.',
    };
  }
  return {
    titulo: 'Convite enviado',
    descricao: 'Ainda não identificamos nenhuma resposta sua. Use o link do convite original pra começar.',
  };
};

export default function StatusContainer() {
  const { company, interviewType, denuncia, entrevistaId } = useParams();
  const [searchParams] = useSearchParams();
  const token = (searchParams.get('t') || '').toString().trim();

  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const carregar = async () => {
      if (!company || !interviewType || !denuncia || !entrevistaId || !token) {
        if (!cancelled) {
          setErro('Link incompleto. Confira se você copiou o endereço inteiro do e-mail/WhatsApp.');
          setLoading(false);
        }
        return;
      }
      try {
        const result = await fetchInterviewByAccessToken({
          company: company.toLowerCase(),
          interviewTypeKey: normalizeInterviewTypeKey(interviewType),
          denuncia,
          entrevistaId,
          token,
        });
        if (cancelled) return;
        if (!result?.interview) {
          setErro('Não encontramos essa entrevista. O link pode estar incorreto.');
        } else {
          setStatus(resolveStatus(result.interview));
        }
      } catch (error) {
        console.error('Erro ao consultar status da entrevista:', error);
        if (!cancelled) {
          setErro('Não foi possível confirmar seu link — ele pode ter expirado ou ser inválido.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    carregar();
    return () => {
      cancelled = true;
    };
  }, [company, interviewType, denuncia, entrevistaId, token]);

  return (
    <StatusPage>
      {loading && <p>Consultando status…</p>}
      {!loading && erro && (
        <>
          <h1>Não foi possível consultar</h1>
          <p>{erro}</p>
        </>
      )}
      {!loading && !erro && status && (
        <>
          <h1>{status.titulo}</h1>
          <p>{status.descricao}</p>
          {isRecruitmentType(interviewType) && (
            <AvisoIA>
              Esta entrevista é conduzida e pré-analisada com apoio de inteligência artificial (IA). A decisão final de avanço no processo seletivo é sempre revisada por um recrutador humano.
            </AvisoIA>
          )}
        </>
      )}
    </StatusPage>
  );
}

const StatusPage = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #F8F9FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 25px;
  h1 {
    font-size: 32px;
    color: #333;
    font-family: "Poppins", sans-serif;
  }
  p {
    font-size: 18px;
    color: #666;
    font-family: "Poppins", sans-serif;
    margin-top: 10px;
    max-width: 480px;
  }
`;

const AvisoIA = styled.p`
  font-size: 13px !important;
  color: #888 !important;
  margin-top: 24px !important;
  max-width: 420px;
  border-top: 1px solid #E2E5EA;
  padding-top: 16px;
`;
